// extracted by mini-css-extract-plugin
export default {"edit":"GeneralInfo_edit__NDAc6","cancel":"GeneralInfo_cancel__Y2CxH"};